import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import { map, mergeMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { ImagilityBaseResponse } from '../../../data/models/response.model';
import { TaskStepStatusPayload } from '../green-card-models/task-step-status-payload';
import * as fromFormDirtySelector from '../../../app-state/selectors/dirty-form.selector';
import * as fromFormDirtyReducer from '../../../data/models/app-state';
import * as DirtyForm from '../../../app-state/actions/dirty-form.actions';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { SubTaskDetails } from '../../../data/models/subTaskDetails.model';
import * as greenCardSubTask from './../green-card-store/actions/greencard-subtask.actions';
import * as Task from '../../superTask/task-state/actions/task.actions';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { TaskSummaryOverview } from 'app-models';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Injectable({
  providedIn: 'root'
})
export class GreenCardService {

  public userTypeRole;

  constructor(
    private http: HttpClient,
    private ngxUiLoaderService: NgxUiLoaderService,
    private store: Store<fromFormDirtyReducer.FormStateModel>,
    private matDialog: MatDialog,
    private toastrService: ToastrService,
    private petitionerService: PetitionerService
  ) {
    this.userTypeRole = sessionStorage.getItem('userTypeRole');
  }

  getStates(countryCode: string) {
    return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status) {
          return response.data;
        }
      })
    );
  }

  updateTaskStepStatus(payload: TaskStepStatusPayload, taskId: number, actionCode: string, superTaskId: number) {
    this.http.post(`/greenCard/task/${taskId}/actionCode/${actionCode}`, payload).pipe(
      take(1),
      mergeMap((statusChangeResponse: ImagilityBaseResponse) => {
        if (statusChangeResponse.status === 200) {
          this.toastrService.success(statusChangeResponse.message, 'Success');
        } else {
          CustomErrorToastComponent.showErrorToast(this.toastrService, statusChangeResponse.message);
        }
        //   return this.petitionerService.getTask(taskId);
        // }),
        // mergeMap((subTaskDetails: SubTaskDetails) => {
        //   subTaskDetailsVar = subTaskDetails;
        //   this.store.dispatch(new greenCardSubTask.SetGCSubTask(subTaskDetails));
        return this.petitionerService.getSuperTask(superTaskId);
      })
    ).subscribe((taskSummaryOverview: TaskSummaryOverview) => {
      this.store.dispatch(new Task.SetTaskSummaryOverview(taskSummaryOverview));
      // if (payload.statusCode === 'INPROGRESS' && taskSummaryOverview) {
      //   const subTask = taskSummaryOverview.subTaskList.find(x => x.id === taskId);
      //   const stepIndex = subTask.stepOverviewList.findIndex(x => x.layoutCode === actionCode);
      //   const nextCompleteStep = subTask.stepOverviewList.find((x, i) => i > stepIndex && x.stepStatusCode === 'COMPLETE');
      //   if (nextCompleteStep) {
      //     this.updateTaskStepStatus(payload, taskId, nextCompleteStep.layoutCode, superTaskId);
      //   }
      // }
    });
  }

  onStepMarkComplete(payload: TaskStepStatusPayload, taskId: number, actionCode: string, superTaskId: number) {
    this.updateTaskStepStatus(payload, taskId, actionCode, superTaskId);
  }

  onStepCloseDirtyCheck() {
    return this.store.select(fromFormDirtySelector.selectFormDirty).pipe(
      take(1),
      mergeMap(dirtyObj => {
        if (!dirtyObj.dirty) {
          return of(true);
        } else {
          this.ngxUiLoaderService.stopAll();
          return this.matDialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'If you leave before saving, all changes made on the page will be lost. Do you wish to continue?'
              },
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).afterClosed().pipe(
            map((confirmed: boolean) => {
              return confirmed;
            })
          );
        }
      })
    );
  }

  refreshTheTask(superTaskId: number) {
    this.petitionerService.getSuperTask(superTaskId)
    .pipe(take(1))
    .subscribe((taskSummaryOverview: TaskSummaryOverview) => {
      this.store.dispatch(new Task.SetTaskSummaryOverview(taskSummaryOverview));
    });
  }

}
